<template>
    <div
        v-if="hasProShows"
        class="widget recent-episode-widget"
    >
        <players-loader
            v-slot:default="{
                players,
                formLoading,
                playersError,
                methods,
            }"
            :api-urls="apiUrls"
            :items-limit="5"
            :items-type="itemsType"
        >
            <widget-header
                players-type="archive"
                @change="methods.getPlayers"
            >
                Recent Archive Players
            </widget-header>
            <div class="widget-body">
                <ul
                    v-if="! playersError && 0 < players.length"
                    class="players-listing"
                >
                    <player-item
                        v-for="player in players"
                        :key="player.hash"
                        :url="`/shows/${player.showHash}/?edit=true&type=${itemsType}&player=${player.hash}`"
                        :show-title="player.title"
                        :player-title="player.name"
                    />
                </ul>
                <players-messages
                    :form-loading="formLoading"
                    :players-error="playersError"
                    :players="players"
                />
            </div>
        </players-loader>
    </div>
</template>

<script>
import WidgetHeader from './WidgetHeader';
import PlayerItem from './PlayerItem';
import PlayersLoader from './PlayersLoader';
import PlayersMessages from './PlayersMessages';

export default {
    components: {
        WidgetHeader,
        PlayerItem,
        PlayersLoader,
        PlayersMessages,
    },

    props: {
        hasProShows: {
            type: Boolean,
            required: true,
        },
    },

    data: () => ({
        apiUrls: {
            all: '/api/players',
            show: '/api/shows/{hash}/players',
        },
        itemsType: 'archive',
    }),
};
</script>
